import { autobind } from 'core-decorators';
import { Component } from 'react';
import Alert from '/@/components/bayer/alert';
import { CornPhenologyChart, SoyPhenologyChart } from '/@/components/phenology-chart';
import { _, _lazy } from '/@/locale';
import styles from './styles.module.css';

@autobind
export class CornPhenology extends Component {
    static label = _lazy('Fenología');
    static icon = 'phenology';

    render() {
        const { productRecommendations } = this.props;

        return (
            <div className={styles.root}>
                <p>
                    {_(
                        'Conocer la fenología te permitirá un ajuste de la fecha de siembra según período crítico del cultivo y un pronóstico de la incidencia de plagas, lo cual se vuelve esencial para un correcto manejo.'
                    )}
                </p>
                {productRecommendations.some((s) => s.isUsingFrostDate) && (
                    <Alert severity='blue' sx={{ width: 'fit-content' }}>
                        {_(
                            'La estimación de madurez fisiológica en el cultivo se establece según la fecha probable de la primera helada con una probabilidad de ocurrencia mayor del 50%'
                        )}
                    </Alert>
                )}
                <CornPhenologyChart
                    products={productRecommendations.map((productRecommendation) => ({
                        id: productRecommendation.id,
                        name: productRecommendation.profile.product.name,
                        phenology: productRecommendation.phenology,
                        gdus: productRecommendation.gdus,
                    }))}
                />
            </div>
        );
    }
}

@autobind
export class SoyPhenology extends Component {
    static label = _lazy('Fenología');
    static icon = 'phenology';

    render() {
        const { productRecommendations } = this.props;

        return (
            <div className={styles.root}>
                <p>
                    {_(
                        'Conocer la fenología te permitirá un ajuste de la fecha de siembra según período crítico del cultivo y un pronóstico de la incidencia de plagas, lo cual se vuelve esencial para un correcto manejo.'
                    )}
                </p>
                <SoyPhenologyChart
                    products={productRecommendations.map((productRecommendation) => ({
                        id: productRecommendation.id,
                        name: productRecommendation.profile.product.name,
                        phenology: productRecommendation.phenology,
                    }))}
                />
            </div>
        );
    }
}
